<template>
  <div class="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-romance-red selection:text-white">

    <div class="fixed top-[-10%] left-[-10%] w-[50%] h-[50%] bg-romance-red/20 blur-[120px] rounded-full z-0"></div>
    <div class="fixed bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-pink-600/10 blur-[120px] rounded-full z-0"></div>

    <nav class="flex justify-between items-center px-6 sticky top-0 z-50 backdrop-blur-xl border-b border-white/5 bg-black/20">
      <div class="flex items-center group cursor-pointer" @click="router.push('/')">
        <img src="@/assets/logo_red_2.png" class="h-16 w-auto" alt="RED Logo">
      </div>

      <div class="flex items-center gap-6">
        <button @click="goToAuth" class="hidden md:block text-sm font-bold hover:text-romance-red transition text-gray-400">Explorar</button>
        <button @click="goToAuth" class="px-6 py-2.5 bg-white text-black font-black rounded-full hover:bg-romance-red hover:text-white transition-all transform active:scale-95 shadow-xl">
          ENTRAR
        </button>
      </div>
    </nav>

    <header class="relative px-6 pt-20 pb-32 flex flex-col items-center text-center z-10">
      <div class="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 mb-8 animate-fade-in">
        <span class="relative flex h-2 w-2">
          <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
          <span class="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
        </span>
        <span class="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400">+50 Mujeres Nicaragüenses Online</span>
      </div>

      <h1 class="text-6xl md:text-8xl font-black tracking-tighter leading-[0.85] mb-8 uppercase italic">
        Tu fantasía <br/>
        <span class="text-transparent bg-clip-text bg-gradient-to-r from-romance-red via-pink-500 to-orange-400">Sin Filtros.</span>
      </h1>

      <p class="max-w-lg text-gray-400 text-lg md:text-xl leading-relaxed mb-12">
        La plataforma más exclusiva de Nicaragua para chatear con mujeres reales.
      </p>

      <div class="flex flex-col md:flex-row gap-4 w-full max-w-md">
        <button @click="goToAuth" class="flex-1 py-5 bg-romance-red text-white font-black rounded-2xl shadow-[0_20px_50px_rgba(239,68,68,0.3)] hover:brightness-110 transition-all text-lg uppercase italic tracking-widest">
          Empezar Ahora
        </button>
        <button @click="goToAuth" class="flex-1 py-5 bg-white/5 backdrop-blur-md border border-white/10 text-white font-black rounded-2xl hover:bg-white/10 transition-all text-lg uppercase italic tracking-widest">
          Ver Modelos
        </button>
      </div>
    </header>

    <section class="px-6 py-20 relative z-10 max-w-7xl mx-auto">
      <h2 class="text-3xl font-black mb-12 uppercase italic tracking-tighter">Match del momento</h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div v-for="(model, i) in models" :key="model.id"
             @click="goToAuth"
             :class="['relative overflow-hidden rounded-[3rem] group cursor-pointer aspect-[4/5] shadow-2xl transition-all hover:-translate-y-2',
                      i === 1 ? 'md:scale-110 md:z-20 border-2 border-romance-red/30' : 'opacity-80 hover:opacity-100']">
          <img :src="model.img" class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" />
          <div class="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-90"></div>
          <div class="absolute bottom-8 left-8 right-8 text-left">
            <h3 class="text-3xl font-black italic">{{ model.name }}</h3>
            <p class="text-gray-400 font-medium">{{ model.bio }}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="py-32 px-6 border-t border-white/5 bg-gradient-to-b from-transparent to-black">
      <div class="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-12 text-center">
        <div><h4 class="text-4xl font-black text-white mb-2">100%</h4><p class="text-[10px] font-black uppercase text-gray-500">Reales</p></div>
        <div><h4 class="text-4xl font-black text-white mb-2">24/7</h4><p class="text-[10px] font-black uppercase text-gray-500">Soporte</p></div>
        <div><h4 class="text-4xl font-black text-white mb-2">🔒</h4><p class="text-[10px] font-black uppercase text-gray-500">Privacidad</p></div>
        <div><h4 class="text-4xl font-black text-white mb-2">+50k</h4><p class="text-[10px] font-black uppercase text-gray-500">Usuarios</p></div>
      </div>
    </section>

    <footer class="p-12 text-center border-t border-white/5">
      <div class="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-6">
        <router-link to="/terms" class="text-[9px] font-bold uppercase tracking-widest text-gray-900 hover:text-gray-700 transition">Términos de Servicio</router-link>
        <router-link to="/privacy" class="text-[9px] font-bold uppercase tracking-widest text-gray-900 hover:text-gray-700 transition">Política de Privacidad</router-link>
        <router-link to="/cookies" class="text-[9px] font-bold uppercase tracking-widest text-gray-900 hover:text-gray-700 transition">Cookies</router-link>
        <router-link to="/compliance" class="text-[9px] font-bold uppercase tracking-widest text-gray-900 hover:text-gray-700 transition">Cumplimiento Legal</router-link>
      </div>
      <p class="text-[9px] font-black tracking-[0.4em] uppercase text-gray-800">© 2026 RED Nicaragua - THE REAL DEVS</p>
    </footer>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

const models = [
  { id: 1, name: 'SHEYLA', age: 22, bio: 'Estelí • Coqueta', img: 'https://ik.imagekit.io/matchiapp/front_profile.png?q=80&w=600' },
  { id: 2, name: 'MARCELA', age: 24, bio: 'Managua • Atrevida', img: 'https://ik.imagekit.io/matchiapp/marcela.png?q=80&w=600' },
  { id: 3, name: 'VALERIA', age: 20, bio: 'León • Romántica', img: 'https://ik.imagekit.io/matchiapp/valeria.png?q=80&w=600' },
]

onMounted(() => {
  const user = localStorage.getItem('user')
  const token = localStorage.getItem('token')
  if (user && token) {
    router.push('/app')
  }
})

const goToAuth = () => {
  router.push('/signin')
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;700;900&display=swap');
.font-sans { font-family: 'Inter', sans-serif; }

@keyframes fade-in {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fade-in { animation: fade-in 1s ease-out; }
</style>